/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { IndexDependencies } from './dependenciesIndexClass.generated';
import { concatDependencies } from './dependenciesConcat.generated';
import { setDifferenceDependencies } from './dependenciesSetDifference.generated';
import { sizeDependencies } from './dependenciesSize.generated';
import { subsetDependencies } from './dependenciesSubset.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSetSymDifference } from '../../factoriesAny.js';
export var setSymDifferenceDependencies = {
  IndexDependencies: IndexDependencies,
  concatDependencies: concatDependencies,
  setDifferenceDependencies: setDifferenceDependencies,
  sizeDependencies: sizeDependencies,
  subsetDependencies: subsetDependencies,
  typedDependencies: typedDependencies,
  createSetSymDifference: createSetSymDifference
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSetSymDifference.generated.js
// module id = 650
// module chunks = 0